import * as React from "react"

import { useSelector } from "react-redux"
import {
  selectProductLinks,
  selectClassroomActiveProductInfo,
  selectTecla2Link
} from "../../modules/products/selectors"
import { StyledTitle } from "./StyledProductLinks"
import Link from "./Link"

const ProductLinks: React.FC = () => {
  const { studentLinks, teacherLinks } = useSelector(selectProductLinks)
  const { type } = useSelector(selectClassroomActiveProductInfo)
  const tecla2Link = useSelector(selectTecla2Link)

  const hasTecla2Link = tecla2Link && tecla2Link.href && tecla2Link.href !== ""

  let teacherLinksToShow = teacherLinks
  if (teacherLinks.length > 0 && hasTecla2Link) {
    teacherLinksToShow = [...teacherLinks, tecla2Link]
  } else if (teacherLinks.length === 0 && hasTecla2Link) {
    teacherLinksToShow = [tecla2Link]
  }

  return (
    <>
      <StyledTitle>Öppna klassrummets läromedel</StyledTitle>
      {studentLinks.length > 0 && (
        <Link
          links={studentLinks}
          text={type === "adapt" ? "Tomoyo Matematik" : "Elevbok"}
          id="student-links"
        />
      )}
      {teacherLinksToShow.length > 0 && (
        <Link
          links={teacherLinksToShow}
          text="Lärarhandledning"
          id="teacher-links"
        />
      )}
    </>
  )
}

export default ProductLinks
